<template>
  <v-card>
    <v-card-title>
      <h1>{{ $t('Nueva conversación') }}</h1>
    </v-card-title>
    <v-card-text class="py-0">
      <v-checkbox
        v-if="userIsSuperAdmin"
        v-model="newThreadData.send_all_customers"
        label="Seleccionar todos los clientes"
      ></v-checkbox>
      <og-user-select
        v-if="!sendAllCustomers && users.length > 0"
        ref="userSelector"
        :users="users"
        :key="sendAllCustomers"
        v-model="newThreadData.user_id"
        :multiple="true"
        :counter="15"
        label="Enviar a los siguientes clientes"
      ></og-user-select>
      <og-user-select
        v-if="userIsSuperAdmin && sendAllCustomers && users.length > 0"
        ref="userExclusionsSelector"
        :users="users"
        :key="sendAllCustomers"
        v-model="newThreadData.exclusion_user_ids"
        label="Excluir a los siguientes clientes"
        :multiple="true"
      ></og-user-select>

      <v-select
        v-model="selectedClavedats"
        :items="formattedCompaniesOptions"
        item-text="text"
        item-value="value"
        solo
        chips
        multiple
        label="Asociar mensajes a empresas"
        @change="onChangeClavedats"
        @input="onInputClavedats"
      ></v-select>
      <v-alert :value="true" type="info" class="black--text">
        El campo de arriba sirve para que se le asocie a cada conversación una empresa del usuario.
        Solo una empresa puede ser asociada por conversación. el campo tiene el formato "Nombre del
        usuario => Empresa".
      </v-alert>
      <v-alert v-if="!userIsSuperAdmin" :value="maxLimitReceivers" type="error">
        Has seleccionado más destinatarios de los permitidos (máximo 15).
      </v-alert>
      <v-text-field solo v-model="newThreadData.title" label="Título del mensaje"></v-text-field>
      <custom-editor
        this.content
        v-model="newThreadData.message"
        @input="updateMessage"
      ></custom-editor>
      <!-- <aru-wysiwyg-editor v-model="newThreadData.message"></aru-wysiwyg-editor> -->

      <!-- <v-textarea
        v-model="newThreadData.message"
        name="message"
        label="Mensaje"
        value="Hola. Estaba interesado en concertar una cita con ustedes."
      ></v-textarea> -->
      <v-autocomplete
        v-model="newThreadData.categories"
        :items="['Fiscal', 'Laboral', 'Contable', 'LOPD', 'Otros']"
        label="Categoría"
        chips
        solo
      ></v-autocomplete>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click.native="$emit('closeForm')">
        Cerrar
      </v-btn>
      <v-btn
        color="primary"
        :disabled="(maxLimitReceivers && !userIsSuperAdmin) || isSending"
        @click="sendAllCustomers ? (showConfirmCreateNewThreadModal = true) : newThread()"
      >
        <v-progress-circular v-if="isSending" indeterminate color="primary"></v-progress-circular>
        Enviar
      </v-btn>
    </v-card-actions>
    <!-- Modal to delete bulk contacts -->
    <v-layout row justify-center>
      <v-dialog v-model="showConfirmCreateNewThreadModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Nueva conversación') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de crear una conversación con todos los usuarios?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showConfirmCreateNewThreadModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="newThread()">
              {{ $t('Enviar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
  </v-card>
</template>

<script>
import ThreadAPI from '@/modules/myconsultant/services/thread.js';
import OgUserSelect from '@/components/commons/form/inputs/OgUserSelect.vue';
// import AruWysiwygEdito/r from '@/components/commons/form/inputs/AruWysiwygEditor.vue';
import CustomEditor from '@/components/commons/form/inputs/CustomEditor.vue';
import ProfileAPI from '@/services/api/profile.js';

export default {
  components: {
    OgUserSelect,
    // AruWysiwygEditor,
    CustomEditor,
  },
  props: ['customers'],
  data() {
    return {
      newThreadData: {
        user_id: this.customers ? this.customers : '',
        title: '',
        message: '',
        categories: [],
        exclusion_user_ids: [],
        send_all_customers: false,
      },
      selectedClavedats: [],
      companiesOptions: [],
      threadForm: false,
      users: [],
      maxLimitReceivers: false,
      isSending: false,
      showConfirmCreateNewThreadModal: false,
    };
  },
  mounted() {
    ProfileAPI.getSelectActiveCustomerProfiles().then(res => {
      this.users = res.data.data;
    });

    if (localStorage.getItem('user')) {
      let user = JSON.parse(localStorage.getItem('user'));
      let categories = user.categories;
      this.newThreadData.categories = categories[0];
    }
    this.newThreadData.user_id = this.customers;
  },
  computed: {
    receivers() {
      return this.newThreadData.user_id || [];
    },
    userIsSuperAdmin() {
      const userRoleNames = this.$store.getters.userRoleNames;
      return userRoleNames.includes('superadmin');
    },
    sendAllCustomers() {
      return this.newThreadData.send_all_customers;
    },
    formattedCompaniesOptions() {
      return this.companiesOptions.map(company => {
        const isDisabled = !!this.selectedClavedats.find(comp => {
          return comp.user_id === company.user_id && comp.clavedat !== company.clavedat;
        });
        return {
          text: `${company.user_name} => ${company.company_name}`,
          value: { clavedat: company.clavedat, user_id: company.user_id },
          disabled: isDisabled,
        };
      });
    },
  },
  methods: {
    setInitialClavedats() {
      this.selectedClavedats = [];
      const userIds = [];
      this.companiesOptions.forEach((company, index) => {
        if (!userIds.includes(company.user_id)) {
          userIds.push(company.user_id);
          this.selectedClavedats.push({
            clavedat: company.clavedat,
            user_id: company.user_id,
          });
        }
      });
    },
    newThread() {
      this.showConfirmCreateNewThreadModal = false;
      this.isSending = true;
      const data = {
        ...this.newThreadData,
        selected_clavedats: this.selectedClavedats,
      };
      ThreadAPI.postThread(data)
        .then(response => {
          console.log(response);
          this.isSending = false;
          this.$emit('created', response.data.data);
          // this.activeThreads.unshift(response.data);
          this.resetNewThreadData();
          this.$emit('created', response.data);
        })
        .catch(() => {
          this.isSending = false;
          // this.resetNewThreadData();
        });
      // axios.post('/thread/vuestore',
      //     this.newThreadData, // the data to post
      //     {} // config
      // ).then(response => {
      //     console.log(response);
      //     this.$emit('created', response.data);
      //     // this.activeThreads.unshift(response.data);
      //     this.resetNewThreadData();
      //     this.threadForm = false;
      // });
      // // console.log(this.newThreadData.categories);
    },
    resetNewThreadData() {
      if (!this.customers.length) {
        this.$refs.userSelector.selected = [];
      }
      this.newThreadData = {
        user_id: this.customers.length ? this.customers : [],
        title: '',
        message: '',
        exclusion_user_ids: [],
        send_all_customers: false,
        // categories: [],
      };
      if (localStorage.getItem('user')) {
        let user = JSON.parse(localStorage.getItem('user'));
        let categories = user.consultant_profile.categories;
        this.newThreadData.categories = categories[0].name;
      }
      this.selectedClavedats = [];
      this.companiesOptions = [];
    },
    updateMessage(value) {
      this.newThreadData.message = value;
    },
  },
  watch: {
    receivers: {
      deep: true,
      handler(val) {
        let total = Array.isArray(val) ? val.length : 1;
        if (val.length) {
          ProfileAPI.getCompaniesOfUsers(this.receivers).then(res => {
            this.companiesOptions = res.data.data;
            this.setInitialClavedats();
          });
        } else {
          this.setInitialClavedats();
        }
        if (total > 15) {
          this.maxLimitReceivers = true;
        } else {
          this.maxLimitReceivers = false;
        }
      },
    },
    sendAllCustomers() {
      this.newThreadData.user_id = [];
      this.newThreadData.exclusion_user_ids = [];
    },
    customers(val) {
      this.newThreadData.user_id = val;
      this.$refs.userSelector.selected = val;
    },
  },
};
</script>
